var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443.479,
    height: 156.678,
    viewBox: "0 0 443.479 156.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_10",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 10",
    transform: "translate(0.295 61.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1",
    "data-name": "\\u30D1\\u30B9 1",
    d: "M91.013,15.939H88.742V13.668H75.054v2.271H72.782V5.973C70.511,6.73,69,8.244,66.666,9.064L64.4,7.487C69,5.216,72.782,3.639,76.568,1.369a23.454,23.454,0,0,0-5.3-3.848A16.235,16.235,0,0,0,67.422-.145L65.151-1.722c5.36-3.091,9.146-6.118,11.417-9.966l2.271.756c-.759.759-.759,1.515-1.515,2.335H87.983v1.513c-3.027,3.847-6.811,7.7-10.659,9.966H91.013ZM72.782-3.993c2.271,1.514,3.786,2.271,5.3,3.848a29.5,29.5,0,0,0,6.875-6.938H75.81C74.3-5.57,73.541-4.813,72.782-3.993Zm15.96,16.084V5.216H75.054v6.875Z",
    transform: "translate(101.136 77.745)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2",
    "data-name": "\\u30D1\\u30B9 2",
    d: "M100.922,15.478H98.587V13.207H81.115v2.271H78.846V1.664h9.9V-4.454H76.575V-6.788H88.749v-4.605H91.02v4.605h12.174v2.334H91.02V1.664h9.9Zm-2.335-4.6V4H81.115v6.875Z",
    transform: "translate(120.178 78.207)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_3",
    "data-name": "\\u30D1\\u30B9 3",
    d: "M114.758-4.16H93.5V-.312c0,6.118-.82,11.48-3.089,15.327L88.14,13.5a27.661,27.661,0,0,0,3.027-6.938V-11.1h23.591Zm.756,18.418H93.5V11.988h9.841V8.9H95.015V7.32h8.326V5.049H95.015l-.756-1.514h3.784C98.8,1.959,100.314,1.2,101.07-.312H95.015V-2.646h19.743V-.312H103.341c-.756.757-1.515,2.271-3.027,3.848a34.566,34.566,0,0,1,9.146-.82c-.759-.757-2.271-1.514-3.027-2.271l1.512-.757a26.132,26.132,0,0,1,7.57,5.362l-2.271.757c0-.757-.756-.757-2.271-1.514h-5.36V7.32H114V8.9h-8.387v3.091h9.9ZM112.487-6.494V-9.521H93.5v3.027Z",
    transform: "translate(138.258 78.669)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4",
    "data-name": "\\u30D1\\u30B9 4",
    d: "M114.283,1.664c-.743,2.334-3.076,5.361-4.588,7.7-2.281,2.271-4.537,4.6-7.562,6.118l-1.512-2.271a33.694,33.694,0,0,0,8.305-6.181c2.281-3.028,3.1-6.118,3.845-9.209H101.363V-4.454H112.77v-6.939h2.281v6.939h12.176v2.271H115.052a26.008,26.008,0,0,0,4.537,9.209,24.448,24.448,0,0,0,8.382,6.181l-2.256,2.271C120.358,11.63,115.821,7.026,114.283,1.664Z",
    transform: "translate(157.769 78.207)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5",
    "data-name": "\\u30D1\\u30B9 5",
    d: "M127.227,12.091c0,1.577,0,2.334-.769,3.091H119.64l-.743-1.514h3.768a2.8,2.8,0,0,0,2.281-.757V7.487H112.77V5.216h12.176V3.639h1.512A17.22,17.22,0,0,0,131.073.612H117.307V-.965h17.534V.612a71.008,71.008,0,0,1-7.613,4.6h12.15V7.487h-12.15ZM138.635.612h-2.281V-3.236H115.795V.612h-2.256V-5.57H130.3c1.512-1.514,2.281-3.847,3.025-5.362h2.281a12.2,12.2,0,0,1-3.025,5.362h6.05ZM121.152-6.327,118.9-5.57a17.7,17.7,0,0,0-3.1-4.6l2.333-.759C118.9-9.417,120.409-7.84,121.152-6.327Zm6.075-.757-1.538.757c-.743-1.514-1.512-3.09-2.256-4.605l1.512-.756C125.689-10.173,126.458-8.6,127.227-7.083Z",
    transform: "translate(176.764 77.745)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_6",
    "data-name": "\\u30D1\\u30B9 6",
    d: "M145.141.15a15.385,15.385,0,0,1-5.281,6.875c3.768,3.091,7.562,4.6,12.15,6.181L150.5,15.478A56.108,56.108,0,0,1,138.348,8.6c-3.871,3.028-7.639,4.6-12.176,6.875l-1.512-2.271c4.537-1.577,8.305-3.091,12.15-6.181A17.667,17.667,0,0,1,130.71.15c-.769,1.514-2.281,2.271-3.794,3.848L125.4,2.421a34.6,34.6,0,0,0,7.562-7.7L135.247-3.7a10.622,10.622,0,0,1-3.025,2.271,27.721,27.721,0,0,0,6.126,7.7c2.256-2.271,4.537-4.6,5.281-7.7-.743-.757-1.512-1.514-2.256-2.271l2.256-1.577c1.512,2.334,4.537,4.668,7.639,7.7L149.756,4C148.166,2.421,146.654,1.664,145.141.15Zm6.126-5.424H124.66V-7.545h12.15v-3.848h2.281v3.848h12.176Z",
    transform: "translate(195.353 78.207)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7",
    "data-name": "\\u30D1\\u30B9 7",
    d: "M144.133,5.216a2.938,2.938,0,0,0-.743-1.577h-3.845V2.126a.75.75,0,0,0-.769.757l-1.512-1.514a17.471,17.471,0,0,0,6.126-3.848c-2.333.757-3.845.757-6.126,1.514l-.743-1.514c.743,0,2.256-.757,3.025-.757,0,0,.743-.757,1.512-1.577-1.512-.757-3.025-2.271-4.537-2.271L138.032-8.6a2.367,2.367,0,0,1,1.512.756c.743-1.576,1.512-2.333,2.256-3.848l1.589.756a15.118,15.118,0,0,1-3.1,3.848l2.281.757a9.31,9.31,0,0,0,2.333-3.09l1.512.82A32.681,32.681,0,0,1,141.8-3.236c.769,0,2.333,0,3.1-.757a2.938,2.938,0,0,0,.743-1.577l.769,1.577c-.769,2.271-3.025,4.6-6.126,6.118h9.151V.612h2.281V2.126h10.638V3.639h-4.537a2.938,2.938,0,0,0-.743,1.577h7.562V6.73H136.52V5.216Zm16.713,10.723h-2.256v-.757h-15.2v.757h-2.333V7.487h19.789Zm-2.256-5.361V9.064h-15.2v1.514Zm0,3.091V12.091h-15.2v1.577ZM153.233-.965A21.1,21.1,0,0,1,145.646.612L144.9-.965h2.256v-9.967h7.588v6.939H148.67V-.965a8.343,8.343,0,0,1,3.794-.757c0-.757-.743-.757-.743-1.514h1.512a11.425,11.425,0,0,1,2.333,3.091l-1.589.757C153.977-.145,153.977-.145,153.233-.965Zm-7.588,4.6c.769,0,.769.82.769,1.577h7.562c.769-.757.769-1.577,1.589-1.577Zm7.588-11.48V-9.417H148.67V-7.84Zm0,3.028V-6.327H148.67v1.514Zm10.638,2.334c0,.757-.743,1.514-1.512,2.334-.743,0-1.512.757-3.025.757l-.743-2.334c2.256,0,3.025,0,3.025-.757a4.16,4.16,0,0,0-2.281-3.091,15.811,15.811,0,0,0,2.281-3.847h-3.794V1.369h-1.512v-12.3h7.562v1.515c-.743,1.576-2.256,2.333-3.025,3.847C163.128-4.813,163.871-3.993,163.871-2.479Z",
    transform: "translate(213.894 77.745)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8",
    "data-name": "\\u30D1\\u30B9 8",
    d: "M160.846,8.244a115.988,115.988,0,0,1-10.587,6.938l-1.589-2.271A51.71,51.71,0,0,0,160.1,7.487H149.49V5.216h11.356V2.883h-3.794V-8.6h3.794c0-.82.82-1.576.82-3.091l2.281.756c0,.759-.769,1.515-.769,2.335h4.537V2.883h-4.537V5.216h12.176V7.487H164.691c3.025,2.334,6.819,3.848,11.433,5.425l-1.538,2.271a68.375,68.375,0,0,1-11.407-6.938v7.7h-2.333ZM155.54-.965a13.136,13.136,0,0,1-5.281,3.848L148.67,1.369c3.1-1.514,4.614-3.091,6.126-3.848Zm0-4.6-1.512.757A15.817,15.817,0,0,0,149.49-7.84L151-9.417A22.333,22.333,0,0,1,155.54-5.57Zm9.92,2.334V-6.327h-6.9v3.091Zm0,4.6V-1.722h-6.9V1.369Zm9.895,0-1.512,1.514a15.4,15.4,0,0,0-5.357-3.848L170-2.479A23.652,23.652,0,0,1,175.355,1.369ZM174.586-8.6c-1.564,1.513-2.333,3.027-3.845,3.784l-2.256-.757c1.512-1.514,3.025-2.271,4.537-4.6Z",
    transform: "translate(232.89 77.745)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9",
    "data-name": "\\u30D1\\u30B9 9",
    d: "M185.477,15.015h-2.256V13.5H163.406v1.514H161.15V-11.1h24.327Zm-2.256-3.848V-8.764H163.406V11.168ZM181.708-2.646h-3.845V8.14c-.769.757-1.512.757-3.025.757h-3.025l-.769-1.577h3.025c.769,0,1.512,0,1.512-.757.769,0,.769-.757.769-1.514v-7.7H164.918V-4.917h11.433V-8.007h1.512v3.091h3.845Zm-8.382,6.181-2.281.757A16.331,16.331,0,0,0,168.02.445l1.512-1.514C171.045.445,171.814,1.959,173.326,3.535Z",
    transform: "translate(252.401 78.669)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    "data-name": "\\u30D1\\u30B9 10",
    d: "M86.4-23.53l-15.2-30.717h0V-23.53H65.9V-61.122h6.811l15.2,29.961h0V-61.122H93.27V-23.53Z",
    transform: "translate(103.482 0.461)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11",
    "data-name": "\\u30D1\\u30B9 11",
    d: "M103.745-23.53,99.962-34.253H87.029L84-23.53h-5.36L90.816-61.122h6.119l12.93,37.592Zm-9.9-32.232h0L88.544-38.1H99.2Z",
    transform: "translate(123.409 0.461)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_12",
    "data-name": "\\u30D1\\u30B9 12",
    d: "M114.092-40.728h-7.644v-3.848h12.925V-26.1c-3.768,2.271-6.819,3.848-11.412,3.848C95.787-22.249,92-32.276,92-43c0-9.966,3.027-18.418,14.445-18.418,7.644,0,12.925,3.027,12.925,10.723h-6.819c0-3.848-1.566-7.7-6.106-7.7-7.634,0-8.39,10.028-8.39,15.391,0,7.7,1.515,17.659,10.661,17.659a8.182,8.182,0,0,0,5.373-2.333Z",
    transform: "translate(144.297 0)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13",
    "data-name": "\\u30D1\\u30B9 13",
    d: "M105.36-42.243c0-9.21,3.794-19.174,15.2-19.174,11.433,0,14.457,9.208,14.457,19.174s-3.025,19.994-14.457,19.994C109.154-22.249,105.36-32.276,105.36-42.243Zm23.532,0c0-5.363-.743-16.147-8.331-16.147-8.382,0-8.382,10.784-8.382,16.147,0,6.119,0,16.9,8.382,16.9C128.148-25.34,128.892-36.124,128.892-42.243Z",
    transform: "translate(165.179 0)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_14",
    "data-name": "\\u30D1\\u30B9 14",
    d: "M129.243-23.53V-41.189L117.81-61.122h6.9l8.331,14.57,9.126-14.57h5.357l-12.15,19.933V-23.53Z",
    transform: "translate(184.644 0.461)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    "data-name": "\\u30D1\\u30B9 15",
    d: "M154.064-23.53l-3.794-10.723H137.351L133.557-23.53H128.2l12.919-37.592h6.126L160.165-23.53Zm-9.843-32.232h0L138.095-38.1h11.433Z",
    transform: "translate(200.887 0.461)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M85.637-41.954H91v24.6C91-8.146,88.667-3.542,78.826-3.542c-9.9,0-12.93-4.6-12.93-13.811v-24.6h6.055v24.6c0,5.36,0,10.723,6.875,10.723,6.055,0,6.811-5.363,6.811-10.723Z",
    transform: "translate(103.482 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M99.5-3.542,84.3-35.015h0V-3.542H78.937V-41.954h6.875l15.2,29.961h0V-41.954h4.542V-3.542Z",
    transform: "translate(123.87 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M92.594-3.542h6.055V-41.954H92.594Z",
    transform: "translate(145.221 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_19",
    "data-name": "\\u30D1\\u30B9 19",
    d: "M109.974-3.542,97.047-41.954h6.813l9.907,30.72h0l9.895-30.72h5.306L116.024-3.542Z",
    transform: "translate(152.183 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M111.29-3.542V-41.954h19.764v3.848H117.365v12.3h12.919v3.848H117.365V-7.387H131.8v3.845Z",
    transform: "translate(174.45 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21",
    "data-name": "\\u30D1\\u30B9 21",
    d: "M139.452-3.542,137.94-14.326c-1.512-3.786-3.025-6.119-8.331-6.119h-2.333v16.9H121.97V-41.954h7.639c7.562,0,15.2,1.515,15.2,9.966,0,5.424-3.794,7.7-8.382,9.21h0c5.357.818,6.126,4.665,7.639,9.272l1.512,9.964Zm-9.843-20.751c5.306,0,9.074-2.271,9.074-7.7,0-5.36-3.768-6.119-9.074-6.119h-2.333v13.814Z",
    transform: "translate(191.147 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_22",
    "data-name": "\\u30D1\\u30B9 22",
    d: "M133.54-10.017c3.076,1.576,6.87,3.091,10.664,3.091,3.845,0,6.87-1.515,6.87-5.363,0-8.451-17.534-8.451-17.534-19.994,0-7.7,6.126-9.966,12.176-9.966a27.316,27.316,0,0,1,8.382,1.515v4.6c-2.281-1.515-6.05-2.271-9.151-2.271-3.025,0-5.281,1.515-5.281,4.6,0,8.451,17.457,7.7,17.457,19.933,0,8.451-6.819,10.784-13.689,10.784a43.9,43.9,0,0,1-9.895-.756Z",
    transform: "translate(209.236 29.967)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_23",
    "data-name": "\\u30D1\\u30B9 23",
    d: "M145.42-3.542h6.055V-41.954H145.42Z",
    transform: "translate(227.809 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24",
    "data-name": "\\u30D1\\u30B9 24",
    d: "M159.321-3.542V-38.106H150.17v-3.848h24.352v3.848h-9.151V-3.542Z",
    transform: "translate(235.235 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25",
    "data-name": "\\u30D1\\u30B9 25",
    d: "M172.557-3.542V-21.2L161.15-41.954h6.87l8.331,15.391,9.126-15.391h5.306L178.607-21.2V-3.542Z",
    transform: "translate(252.401 30.428)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_26",
    "data-name": "\\u30D1\\u30B9 26",
    d: "M66.947-7.394A10.768,10.768,0,0,0,71.49-5.882c2.271,0,3.784-.756,3.784-2.271,0-4.6-9.082-3.848-9.082-10.028,0-3.027,3.027-4.6,6.055-4.6a8.969,8.969,0,0,1,4.542.818V-19.7a10.768,10.768,0,0,0-4.542-1.512c-1.512,0-3.027.756-3.027,2.271,0,3.848,8.326,3.848,8.326,10.028,0,3.784-3.027,5.36-6.055,5.36-1.515,0-3.786-.756-4.542-.756Z",
    transform: "translate(103.943 60.397)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_27",
    "data-name": "\\u30D1\\u30B9 27",
    d: "M76.534-4.8v-8.451l-5.3-9.21h3.027L78.8-15.588l3.848-6.878H85.68l-6.119,9.21V-4.8Z",
    transform: "translate(111.829 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28",
    "data-name": "\\u30D1\\u30B9 28",
    d: "M92.957-4.8V-20.195h0L87.658-4.8H85.387l-5.36-15.391h0V-4.8H77.756V-22.466H81.54L86.146-7.893H86.9l4.54-14.573h3.786V-4.8Z",
    transform: "translate(122.024 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29",
    "data-name": "\\u30D1\\u30B9 29",
    d: "M86.368-4.8V-22.466h3.784c3.786,0,6.878,0,6.878,4.606s-3.091,5.36-6.878,5.36H89.4v7.7Zm3.784-9.272c2.271,0,3.786-.756,3.786-3.784,0-3.091-1.515-3.091-3.786-3.091H89.4v6.875Z",
    transform: "translate(135.488 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_30",
    "data-name": "\\u30D1\\u30B9 30",
    d: "M100.854-4.8v-8.451H94.735V-4.8H91.708V-22.466h3.027v7.634h6.119v-7.634h3.027V-4.8Z",
    transform: "translate(143.836 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_31",
    "data-name": "\\u30D1\\u30B9 31",
    d: "M97.638-13.577c0-4.6,1.512-9.208,7.644-9.208,5.281,0,6.793,4.6,6.793,9.208,0,5.424-1.512,10.028-6.793,10.028C99.15-3.549,97.638-8.153,97.638-13.577Zm11.412,0c0-2.271-.743-7.631-3.768-7.631-3.86,0-4.617,5.36-4.617,7.631,0,3.091.756,8.451,4.617,8.451C108.307-5.126,109.05-10.486,109.05-13.577Z",
    transform: "translate(153.107 60.397)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_32",
    "data-name": "\\u30D1\\u30B9 32",
    d: "M114.37-4.8l-6.819-14.632h0V-4.8h-3.1V-22.466H108.3l6.819,13.814h0V-22.466H117.4V-4.8Z",
    transform: "translate(163.757 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_33",
    "data-name": "\\u30D1\\u30B9 33",
    d: "M116.46-4.8v-8.451l-6.05-9.21h3.768l3.794,6.878,4.614-6.878h2.256l-5.357,9.21V-4.8Z",
    transform: "translate(173.075 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_34",
    "data-name": "\\u30D1\\u30B9 34",
    d: "M119.29-13.577c0-4.6,1.589-9.208,6.87-9.208,5.306,0,6.9,4.6,6.9,9.208,0,5.424-1.589,10.028-6.9,10.028C120.879-3.549,119.29-8.153,119.29-13.577Zm10.664,0c0-2.271,0-7.631-3.794-7.631-3.768,0-3.768,5.36-3.768,7.631,0,3.091,0,8.451,3.768,8.451C129.954-5.126,129.954-10.486,129.954-13.577Z",
    transform: "translate(186.957 60.397)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_35",
    "data-name": "\\u30D1\\u30B9 35",
    d: "M134.512-4.8l-.82-4.6c-.743-2.333-1.512-3.091-3.768-3.091h-.769v7.7H126.13V-22.466h3.794c3.025,0,6.87,0,6.87,4.606a3.59,3.59,0,0,1-3.845,3.784h0c3.1.82,3.1,2.335,3.845,4.668l.769,4.6Zm-4.588-10.028c2.256,0,3.768-.756,3.768-3.027,0-3.091-1.512-3.091-3.768-3.091h-.769v6.119Z",
    transform: "translate(197.651 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_36",
    "data-name": "\\u30D1\\u30B9 36",
    d: "M144.415-5.126a13.124,13.124,0,0,1-5.306,1.576c-5.357,0-7.639-5.36-7.639-10.028,0-4.6,2.281-9.208,7.639-9.208,3.025,0,6.05,1.576,6.05,5.424h-3.794c0-1.576-.743-3.848-3.025-3.848-3.076,0-3.845,4.6-3.845,6.875,0,3.848.769,8.451,5.357,8.451a10.851,10.851,0,0,0,4.563-1.512Z",
    transform: "translate(205.999 60.397)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_37",
    "data-name": "\\u30D1\\u30B9 37",
    d: "M147.141-4.8v-8.451h-6.87V-4.8H137.99V-22.466h2.281v7.634h6.87v-7.634h3.025V-4.8Z",
    transform: "translate(216.193 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_38",
    "data-name": "\\u30D1\\u30B9 38",
    d: "M144.24-4.8V-22.466h9.843v1.515h-6.819v6.119h6.075v1.576h-6.075v6.875h6.819V-4.8Z",
    transform: "translate(225.964 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_39",
    "data-name": "\\u30D1\\u30B9 39",
    d: "M149.29-7.394a13.96,13.96,0,0,0,5.281,1.512c1.512,0,3.025-.756,3.025-2.271,0-4.6-8.305-3.848-8.305-10.028,0-3.027,3.025-4.6,6.05-4.6a6.464,6.464,0,0,1,3.794.818V-19.7a8.23,8.23,0,0,0-4.563-1.512,2.414,2.414,0,0,0-2.256,2.271c0,3.848,8.382,3.848,8.382,10.028,0,3.784-3.1,5.36-6.87,5.36-.769,0-3.025-.756-4.537-.756Z",
    transform: "translate(233.859 60.397)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_40",
    "data-name": "\\u30D1\\u30B9 40",
    d: "M158.867-4.8V-20.951H154.33v-1.515h11.407v1.515h-3.845V-4.8Z",
    transform: "translate(241.738 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_41",
    "data-name": "\\u30D1\\u30B9 41",
    d: "M169.1-4.8l-1.564-4.6c0-2.333-.769-3.091-3.025-3.091h-1.512v7.7H159.97V-22.466h4.537c3.025,0,6.87,0,6.87,4.606a3.59,3.59,0,0,1-3.845,3.784h0c2.333.82,3.076,2.335,3.076,4.668l1.512,4.6Zm-4.588-10.028c2.256,0,3.768-.756,3.768-3.027,0-3.091-1.512-3.091-3.768-3.091h-1.512v6.119Z",
    transform: "translate(250.556 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_42",
    "data-name": "\\u30D1\\u30B9 42",
    d: "M177.46-4.8l-1.512-5.424h-6.1L168.335-4.8H165.31l6.05-17.662h3.076L180.511-4.8Zm-4.537-15.391h0l-2.333,8.454H175.2Z",
    transform: "translate(258.904 60.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_43",
    "data-name": "\\u30D1\\u30B9 43",
    d: "M148.815-26.1h0V-61.417H111.538V11.5a35.777,35.777,0,0,1-9.146,1.576,42.145,42.145,0,0,1-9.9-1.576V-61.417H55.21V25.374L36.982-7.678V-61.417H-.3V95.261H36.982V8.468L55.21,40.7V95.261H92.49V19.95a44.011,44.011,0,0,0,9.9.756,37.393,37.393,0,0,0,9.146-.756V95.261h37.277V-26.1ZM29.351-20.734,10.364-53.786H29.351Zm0,108.3H7.337V-43L29.351-5.407ZM84.92-53.786V8.468C71.99,2.288,63.6-10.767,63.6-26.1h0v-27.69ZM63.6,54.514,81.893,87.566H63.6ZM84.92,76.78,63.6,39.188V.017A53.187,53.187,0,0,0,84.92,17.679ZM119.105-53.786h22.078V-26.1A38.292,38.292,0,0,1,119.105,8.468ZM141.184,87.566H119.105V17.679A50.7,50.7,0,0,0,141.184.017Z",
    transform: "translate(0 0)",
    fill: "#474747"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.38ad8639cc4bd24bd13b5da38d1a9d2d.svg";
export { ForwardRef as ReactComponent };